import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './market.css';

const SCREENS = [
  { path: '/market', label: 'Portfolio', exact: true },
  { path: '/market/browse', label: 'Browse' },
  { path: '/market/leaderboard', label: 'Leaderboard' },
];

/** The Market's screen switcher — filter pills, plain names. */
const MarketNav = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return (
    <nav className="ft-pillrow mk-subnav" aria-label="Market screens">
      {SCREENS.map((s) => {
        const on = s.exact ? pathname === s.path : pathname.startsWith(s.path);
        return (
          <button
            key={s.path}
            type="button"
            className={`ft-fpill${on ? ' on' : ''}`}
            aria-pressed={on}
            onClick={() => navigate(s.path)}
          >
            {s.label}
          </button>
        );
      })}
    </nav>
  );
};

export default MarketNav;
